export default "__VITE_ASSET__Cd6JsBvC__"